import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import React, {useState} from 'react';
import Avatar from "@mui/material/Avatar";
import useSignedFileUrl from "../helpers/authenticatedFile";

// The URL is signed rather than fetched, so the browser loads and caches it
// itself and Avatar gets a plain src it can render, lazy-load and reuse.
const AvatarWithLightBox = ({title,picture,className}) => {
    const [isOpen, setIsOpen] = useState(false)
    const {url} = useSignedFileUrl(picture);

    if (!picture) return null;

    return (
        <div>
            <Avatar onClick={(e)=>{e.stopPropagation(); setIsOpen(true);}} alt={title} src={url}  className={className}  />
            {isOpen && (
                <Lightbox
                    mainSrc={url}

                    onCloseRequest={() => setIsOpen(false)}

                />
            )}
        </div>
    );
};

export default AvatarWithLightBox;